"use strict";
import { jsx } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useId, useMemo, useState } from "react";
import { ContentPortal, ContentPortalContainer } from "capitalrx-components-2.0/lib/shell";
import { ShellContext } from "../context";
import { useOwnerModule } from "../hooks";
import styles from "./ContentSubscription.module.css";
export const ContentSubscription = (props) => {
  const { moduleId, channelId, children, params } = props;
  const { registerDynamicChannelSubscription } = useContext(ShellContext);
  const ownerModule = useOwnerModule();
  const [element, setElement] = useState(null);
  const selector = moduleId === null ? `_c_${channelId}` : `_c_${moduleId}_${channelId}`;
  const refHandler = useCallback((ref) => {
    setElement(ref);
  }, []);
  const component = useMemo(() => {
    const ContentSubscriptionContainer = () => /* @__PURE__ */ jsx(ContentPortalContainer, { className: `${styles.container} ${selector}`, refHandler });
    return ContentSubscriptionContainer;
  }, [selector, refHandler]);
  useEffect(() => {
    if (!ownerModule) {
      console.warn("Content Subscription can only be used from within a module.");
      return;
    }
    const deregister = registerDynamicChannelSubscription(moduleId, channelId, {
      module: ownerModule,
      type: "component",
      priority: 0,
      component,
      params
    });
    return () => {
      deregister();
    };
  }, [moduleId, channelId, component, params, registerDynamicChannelSubscription]);
  if (!element) return null;
  let renderChildren = children;
  if (typeof children === "function") {
    renderChildren = children();
  }
  return /* @__PURE__ */ jsx(ContentPortal, { container: element, children: renderChildren });
};
export const ActionBar = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsx(ContentSubscription, { moduleId: null, channelId: "app-action-bars", children });
};
export const LeftSideBar = (props) => {
  const { id, children } = props;
  const sidebarParams = useMemo(() => {
    return { id };
  }, [id]);
  return /* @__PURE__ */ jsx(ContentSubscription, { moduleId: null, channelId: "app-sidebar-left", params: sidebarParams, children });
};
export const RightSideBar = (props) => {
  const { id, children } = props;
  const sidebarParams = useMemo(() => {
    return { id };
  }, [id]);
  return /* @__PURE__ */ jsx(ContentSubscription, { moduleId: null, channelId: "app-sidebar-right", params: sidebarParams, children });
};
export const Task = (props) => {
  const { title, onClose, children } = props;
  const id = useId();
  const params = useMemo(() => {
    return {
      id,
      title,
      onClose
    };
  }, [id, title, onClose]);
  return /* @__PURE__ */ jsx(ContentSubscription, { moduleId: null, channelId: "flyout-tasks", params, children });
};
